// SPDX-License-Identifier: AGPL-3.0-or-later
import {MessageNotifications} from '@app/vendor/constants/NotificationConstants';
export interface ChannelUnreadStateInput {
	unreadCount: number;
	mentionCount: number;
	isMuted: boolean;
	showFadedUnreadOnMutedChannels: boolean;
	unreadBadgesLevel?: number | null;
}
export interface ChannelUnreadState {
	hasUnreadMessages: boolean;
	hasMentions: boolean;
	isHighlight: boolean;
	shouldShowUnreadIndicator: boolean;
	hasVisibleUnread: boolean;
}
export function getChannelUnreadState({
	unreadCount,
	mentionCount,
	isMuted,
	showFadedUnreadOnMutedChannels,
	unreadBadgesLevel,
}: ChannelUnreadStateInput): ChannelUnreadState {
	const hasUnreadMessages = unreadCount > 0;
	const rawHasMentions = mentionCount > 0;
	let shouldShowUnreadIndicator: boolean;
	let isHighlight: boolean;
	let mentionsVisible: boolean;
	if (unreadBadgesLevel === MessageNotifications.NO_MESSAGES) {
		shouldShowUnreadIndicator = false;
		mentionsVisible = false;
		isHighlight = false;
	} else if (unreadBadgesLevel === MessageNotifications.ONLY_MENTIONS) {
		shouldShowUnreadIndicator = false;
		mentionsVisible = rawHasMentions;
		isHighlight = rawHasMentions;
	} else if (unreadBadgesLevel === MessageNotifications.ALL_MESSAGES) {
		shouldShowUnreadIndicator = hasUnreadMessages;
		mentionsVisible = rawHasMentions;
		isHighlight = rawHasMentions || hasUnreadMessages;
	} else {
		shouldShowUnreadIndicator = hasUnreadMessages && (!isMuted || showFadedUnreadOnMutedChannels);
		mentionsVisible = rawHasMentions;
		isHighlight = rawHasMentions || (hasUnreadMessages && !isMuted);
	}
	return {
		hasUnreadMessages,
		hasMentions: mentionsVisible,
		isHighlight,
		shouldShowUnreadIndicator,
		hasVisibleUnread: mentionsVisible || shouldShowUnreadIndicator,
	};
}
